import React from 'react'
import whyicon1 from "../assets/img/authentic.png"
import whyicon2 from "../assets/img/fast.png"
import whyicon3 from "../assets/img/high-quality.png"
import whyicon4 from "../assets/img/dedication.png"

export const Whyus = () => {
    return (
        <>
            <div class="whyus-section" id="why" data-astro-cid-j7pv25f6="">
                <div className="section-header">
                    <h3>Why Choose Us?</h3>
                    <p>Here is why we are different from Others</p>
                    <div className="line-mf" style={{ textAlign: "center" }}></div>

                </div>

                <div class="section-cards" data-astro-cid-j7pv25f6="">
                    <div class="section-card" data-astro-cid-j7pv25f6="">
                        <span className='why-box'>
                            <img src={whyicon1} alt="" />
                        </span>
                        <span className='why-content'>
                            <h3>
                                100% Authentic Indian Products
                            </h3>
                        </span>

                    </div>
                    <div class="section-card" data-astro-cid-j7pv25f6="">
                        <span className='why-box'>
                            <img src={whyicon2} alt="" />
                        </span>
                        <span className='why-content'>
                            <h3>
                                Global Shipping<br/> Experience
                            </h3>
                        </span>
                    </div>
                    <div class="section-card" data-astro-cid-j7pv25f6="">
                        <span className='why-box'>
                            <img src={whyicon3} alt="" />
                        </span>
                        <span className='why-content'>
                            <h3>
                                Exceptional Quality at Competitive Prices
                            </h3>
                        </span>
                    </div>
                    <div class="section-card" data-astro-cid-j7pv25f6="">
                        <span className='why-box'>
                            <img src={whyicon4} alt="" />
                        </span>
                        <span className='why-content'>
                            <h3>
                            Understanding and Supporting Business Needs
                            </h3>
                        </span>
                    </div>
                </div>
            </div>
        </>

    )
}
